import { Country } from '../country';

export type TierType = 'shipping' | 'discount';

export interface Tier {
  threshold: number;
  discountPercent: number;
  type: TierType;
}

export interface UserTypeTiers {
  registeredFirstOrder: Tier[];
  registeredReturning: Tier[];
  guest: Tier[];
}

export type BMSMTiersConfig = Record<Country, UserTypeTiers>;
